<template>
  <div class="tab-wrapper">
    <div class="tab maincategories">
      <div
        v-for="category in categories"
        :key="category.id"
        class="category-item"
        :class="{ activeItem: category.id === activeMain.id }"
        @click.prevent="chooseMain(category)"
      >
        <img
          :src="
            category.id === activeMain.id
              ? '/' + category.icon_active
              : '/' + category.icon
          "
        />
        {{ category.title || "" }}
      </div>
    </div>
    <div class="tabs-divider" v-if="subs.length > 0">
      <span v-if="subs.length > 0">></span>
    </div>
    <div class="tab subcategories" v-if="subs.length > 0">
      <div
        v-for="category in subs"
        :key="category.id"
        class="category-item"
        :class="{ activeItem: category.id === activeSub.id }"
        @click.prevent="chooseSub(category)"
      >
        {{ category.title || "" }}
      </div>
    </div>
    <div class="tabs-divider" v-if="subsubs.length > 0">
      <span v-if="subsubs.length > 0">></span>
    </div>

    <div class="tab subsubcategories" v-if="subsubs.length > 0">
      <div
        v-for="category in subsubs"
        :key="category.id"
        class="category-item"
        :class="{ activeItem: category.id === activeSubSub.id }"
        @click.prevent="chooseSubSub(category)"
      >
        {{ category.title || "" }}
      </div>
    </div>
    <input
      type="hidden"
      name="mainCategory"
      v-if="activeMain !== null"
      :value="activeMain.id"
    />
  </div>
</template>

<script>
export default {
  props: ["categories", "value", "readonly"],
  data() {
    return {
      main: [],
      subs: this.value.main ? this.value.main.subcategory : [],
      subsubs: this.value.sub ? this.value.sub.subcategory : [],
      loading: false,
      activeMain: this.value.main ? this.value.main : {},
      activeSub: this.value.sub ? this.value.sub : {},
      activeSubSub: this.value.subsub ? this.value.subsub : {},
    };
  },
  methods: {
    chooseMain(category) {
      if (this.readonly !== undefined) {
        return;
      }
      this.subs = category.subcategory;
      this.subsubs = [];
      this.activeMain = category;
      this.activeSub = {};
      this.activeSubSub = {};
      this.setCategories();
    },
    chooseSub(category) {
      if (this.readonly !== undefined) {
        return;
      }

      this.subsubs = category.subcategory;
      this.activeSub = category;
      this.activeSubSub = {};
      this.setCategories();
    },
    chooseSubSub(category) {
      if (this.readonly !== undefined) {
        return;
      }

      this.activeSubSub = category;
      this.setCategories();
    },

    setCategories() {
      let valid = true;

      if (this.activeMain === {}) {
        valid = false;
      }

      if (
        this.subs.length > 0 &&
        Object.keys(this.activeSub).length === 0 &&
        this.activeSub.constructor === Object
      ) {
        valid = false;
      }
      if (
        this.subsubs.length > 0 &&
        Object.keys(this.activeSubSub).length === 0 &&
        this.activeSubSub.constructor === Object
      ) {
        valid = false;
      }

      this.$emit("input", {
        main: this.activeMain,
        sub: this.activeSub,
        subsub: this.activeSubSub,
        valid,
      });
    },
  },
  created() {
    // if (this.value.main !== null) {
    //   this.subs = this.value.main.subcategory;
    //   console.log("subs", this.subs);
    // }
  },
  mounted() {
    // console.log("tes", this.value.main);
    // if (this.value.main !== null) {
    //   this.subs = this.value.main.subcategory;
    //   console.log("subs", this.subs);
    // }
    // if (this.value.sub !== null) {
    //   this.subs = this.value.sub.subcategory;
    // }
  },
  computed: {},
};
</script>

<style>
</style>